// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"61b1111dba59a89ff935","293":"8c3c2e028537e729594c","518":"69486b2bf780d5e294b3","779":"4254a08da31f88d55038"}[chunkId] + ".js";
};